// extracted by mini-css-extract-plugin
export default {"root":"Tracking_root__3JxQL","main":"Tracking_main__2Kjyw","arrowLink":"Tracking_arrowLink__1GnEF","left":"Tracking_left__3dSb3"};